import axios from 'axios'
import { API_URL, getAuthHeader } from '@/services/api.service.js'
import { logger } from '@/utils/logger'

/**
 * Fetch last states of each type for a board
 */
export const fetchLastStates = async ({ boardId, processId = null, signal }) => {
  try {
    const ret = await axios.get(`${await API_URL()}/states/${boardId}/${processId}`, {
      headers: { ...(await getAuthHeader()) },
      signal
    })

    if (ret.status === 200) {
      return ret.data
    } else {
      return null
    }
  } catch (error) {
    if (signal?.aborted) {
      return null
    }

    logger.info(error.message)
    return null
  }
}

/**
 * Fetch latest merge and refresh states for multiple scenarios.
 */
export const fetchLastStatesBatch = async ({ boardId, boardIds }) => {
  try {
    const ret = await axios.post(
      `${await API_URL()}/states/${boardId}/batch`,
      { data: { boardIds } },
      { headers: { ...(await getAuthHeader()) } }
    )

    return ret.status === 200 ? ret.data : null
  } catch (error) {
    logger.info(error.message)
    return null
  }
}
